import { BankSEOConfig } from '../types';

let bankSEOConfig = getBankConfig();

function getBankConfig(): BankSEOConfig {
  switch (process.env.REACT_APP_BANK) {
    case 'spks': {
      return require('./config.spks').default;
    }
    case 'kreditbanken': {
      return require('./config.kreditbanken').default;
    }
    case 'djurslandsbank': {
      return require('./config.djurslandsbank').default;
    }
    case 'landbobanken': {
      return require('./config.landbobanken').default;
    }
    case 'nordjyskebank': {
      return require('./config.nordjyskebank').default;
    }
    case 'skjernbank': {
      return require('./config.skjernbank').default;
    }
    default: {
      return require('./config.default').default;
    }
  }
}

export default bankSEOConfig;
